import { computed } from 'vue';
import { useStore } from 'vuex';

import storeModule from './storeModule';
import provider from './provider';


const DEFAULT_STORE_NAMESPACE = 'customizer';

const useCustomizer= ({ namespace = DEFAULT_STORE_NAMESPACE, init = false } = {}) => {
	const store = useStore();


	const $module = (name) => `${namespace}/${name}`;
	if (init) {
		if (store.hasModule(namespace)) {
			store.commit($module`reset`);
		} else {
			store.registerModule(namespace, storeModule);
		}
	}


	// customizer stuff
	const config = computed(() => store.getters[$module`threeAppConfig`]);
	const objectsState = computed(() => store.getters[$module`objectsState`]);

	const updateObjectsState = (payload) => store.dispatch($module`updateObjectsState`, payload);


	// wizard stuff
	const steps = computed(() => store.getters[$module`wizardConfig`]);
	const currentStep = computed(() => store.getters[$module`currentStep`]);
	const stepIndex = computed({
		get: () => store.getters[$module`stepIndex`],
		set: (newIndex) => store.commit($module`setStepIndex`, newIndex),
	});

	const threeApp = computed(() => store.getters[$module`threeApp`]);
	const initThreeApp = () => {
		store.dispatch($module`initThreeApp`);
	};

	const createThreeApp = (...args) => provider.init(...args);

	// panels
	const updatePaddings = (payload) => store.dispatch($module`updatePaddings`, payload);

	// focus
	const handleFocus = (payload) => store.dispatch($module`handleFocus`, payload);
	const focus = (payload) => store.dispatch($module`focus`, payload);

	// data fetching
	const fetchData = (payload) => store.dispatch($module`fetchData`, payload);

	// loadingState
	const loadingState = computed({
		get: () => store.getters[$module`loadingState`],
		set: (payload) => store.commit($module`setLoadingState`, payload),
	});

	const isMobileLandscape = computed({
		get: () => store.getters[$module`isMobileLandscape`],
		set: (payload) => store.commit($module`setMobileLandscape`, payload),
	});

	return {
		fetchData,
		config,
		objectsState,
		updateObjectsState,

		// focus
		handleFocus,
		focus,

		threeApp,
		initThreeApp,
		createThreeApp,

		// wizard stuff
		steps,
		currentStep,
		stepIndex,

		// panels
		updatePaddings,

		// loading
		loadingState,

		isMobileLandscape,
	};
};


export default useCustomizer;
